import TitleBar from "@components/Layout/TitleBar";
import Articles from "@components/PageComponents/News";
import SEO from "@components/SEO";

import { motion } from "framer-motion";
import { NextPage } from "next";
import { useState } from "react";
import { sortArticles } from "@services/utils";

const client = require("contentful").createClient({
  space: process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID,
  accessToken: process.env.NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN,
});

const maxArticles: number = 6;

export async function getStaticProps() {
  const articles = await client.getEntries({ content_type: "blogPost", limit: maxArticles }).then((response: any) => response.items);
  const sortedArticles = sortArticles(articles);

  return {
    props: {
      articles: sortedArticles,
      updatedAt: Date.now(),
    },
    revalidate: 10,
  };
}

type NewsProps = {
  articles: Array<any>;
  updatedAt: number;
};

const News: NextPage<NewsProps> = ({ articles, updatedAt }) => {
  console.info(`Dernière mise à jour : ${new Date(updatedAt).toLocaleTimeString()}`);

  const [posts, setPosts]: any = useState(articles);
  const [loading, setloading] = useState<boolean>(false);

  async function loadMore() {
    setloading(true);
    const skipCount = posts.length;

    const articles = await client.getEntries({ content_type: "blogPost", limit: maxArticles, skip: skipCount }).then((response: any) => response.items);
    const sortedArticles = sortArticles(articles);
    await client.getEntries({ content_type: "blogPost", limit: maxArticles, skip: skipCount }).then((response: any) => {
      setPosts([...posts, ...sortedArticles]);
      setloading(false);
    });
  }

  return (
    <motion.div className="container-padding container-margin container" exit={{ opacity: 0 }}>
      <SEO pageTitle="News et articles | DeathroW Esport" pageDescription="Decouvrez toutes les actualités et communiqués officiels du club Deathrow" />

      <TitleBar subtitle="Toute l'actualité Deathrow">Nos News</TitleBar>

      <section id="articles-list">{posts && <Articles articles={posts} loadMoreCallback={() => loadMore} loading={loading} />}</section>
    </motion.div>
  );
};

export default News;
